import BlockAgents from '@/components/blocks/Admin/Agents/BlockAgents';
import BlockDeletedAgents from '@/components/blocks/Admin/Agents/BlockDeletedAgents';
import BlockEditAgent from '@/components/blocks/Admin/Agents/BlockEditAgent';
import BlockAgentActivity from '@/components/blocks/BlockAgentActivity';
import SuperAdminGuard from '@/services/RouteGuards/SuperAdmin';

export default [
	{
		path: 'users/agents',
		name: 'Agents',
		component: BlockAgents,
		meta: {
			title: `Agents - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'users/agents/deleted',
		name: 'DeletedAgents',
		component: BlockDeletedAgents,
		meta: {
			title: `Deleted Agents - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'users/agent/edit/:id',
		name: 'EditAgent',
		component: BlockEditAgent,
		props: {
			edit: true,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Edit Agent - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'users/agent/new',
		name: 'NewAgent',
		component: BlockEditAgent,
		props: {
			edit: false,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `New Agent - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'agent-activity',
		name: 'AgentActivity',
		component: BlockAgentActivity,
		meta: {
			title: `Agent Activity - ${process.env.VUE_APP_NAME}`
		}
	}
];
